module.exports = __webpack_public_path__ + "img/Icon-perfil.c3de1d55.svg";